import React, { useEffect, useState } from "react";
import "./CreateSupportDocument.css";
import { Input, Drawer } from "antd";
import {
  RiArrowLeftLine,
  RiFileUploadFill,
  RiLinkM,
  RiEditBoxFill,
} from "react-icons/ri";
import UploadComputer from "./UploadComputer/UploadComputer";
import WebsiteUrl from "./WebsiteUrl/WebsiteUrl";
import OwnData from "./OwnData/OwnData";
import { useDispatch, useSelector } from "react-redux";
// import { DocumentsSupportingCreateSuccess } from "../../../../Redux/Actions/user/BuildQuickCreateSupportingDocumentsAction";
const CreateSupportDocument = ({
  isCreateSupportDocument,
  handleCreateSupportDocument,
  workspaceFolderFlag,
  workspace_id,
  folder_id,
  workspaceId,
  workspaceFolderId,
  workspaceByIdStatus,
  folderByIdStatus,
}) => {
  let dispatch = useDispatch();
  const SideClose = "/assets/ModalClose.svg";
  const [isUploadComputer, setIsUploadComputer] = useState(false);
  const [isWebsiteUrl, setIsWebsiteUrl] = useState(false);
  const [isOwnData, setIsOwnData] = useState(false);
  const [name, setName] = useState("");
  const [context, setContext] = useState("");
  const [isDragging, setIsDragging] = useState(false);
  const [DragDropFile, setDragDropFile] = useState("");

  const documentssupportingcreatedata = useSelector(
    (state) =>
      state?.BuildQuickCreateSupportingDocumentsData
        ?.documents_supporting_create_data
  );
  useEffect(() => {
    if (documentssupportingcreatedata) {
      // setTimeout(() => {
      //   dispatch(DocumentsSupportingCreateSuccess(null));
      // }, 3000);
    }
  }, []);

  const handleUploadComputer = () => {
    setIsUploadComputer(true);
    setIsWebsiteUrl(false);
    setIsOwnData(false);
    setDragDropFile("");
  };
  const handleWebsiteUrl = () => {
    setIsUploadComputer(false);
    setIsWebsiteUrl(true);
    setIsOwnData(false);
  };
  const handleOwnData = () => {
    setIsUploadComputer(false);
    setIsWebsiteUrl(false);
    setIsOwnData(true);
  };
  const handleSupportingDocumentButtonClick = () => {
    setIsUploadComputer(false);
    setIsWebsiteUrl(false);
    setIsOwnData(false);
  };
  const handleNameChange = (e) => {
    setName(e.target.value);
  };
  const handleContextChange = (e) => {
    setContext(e.target.value);
  };

  //drag and drop
  const handleDragEnter = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    setIsUploadComputer(true);
    // setIsUploadOutComputer(true);
    // setRunStatusMainData("");
    const files = e.dataTransfer.files;

    setDragDropFile(files);
  };

  return (
    <>
      <Drawer
        placement="right"
        closable={false}
        onClose={handleCreateSupportDocument}
        open={isCreateSupportDocument}
        key="right"
        width={"45%"}
      >
        <img
          className="supporting-document-modal-sideClose"
          src={SideClose}
          alt=""
          onClick={handleCreateSupportDocument}
        />
        <div className="supporting-document-modal-div">
          <h3>Create Supporting Document</h3>
          {isUploadComputer || isWebsiteUrl || isOwnData ? (
            <p
              className="supporting-document-back"
              onClick={handleSupportingDocumentButtonClick}
            >
              <RiArrowLeftLine className="supporting-document-back-svg" /> Back
            </p>
          ) : null}
        </div>
        <div className="supporting-document-input">
          {isUploadComputer || isWebsiteUrl || isOwnData ? null : (
            <>
              <div className="supporting-document-2">
                <label>Supporting document name</label>
                <Input
                  placeholder="Basic usage"
                  name="name"
                  value={name}
                  onChange={handleNameChange}
                />
              </div>
              {/* <div className="supporting-document-2">
                <label>
                  Context to frame reference data (edit if required)
                </label>
                <Input
                  placeholder="Basic usage"
                  name="context"
                  value={"This is the " + name + ":"}
                  onChange={handleContextChange}
                />
              </div> */}
            </>
          )}

          {isUploadComputer ? (
            <UploadComputer
              workspaceFolderFlag={workspaceFolderFlag}
              workspace_id={workspace_id}
              folder_id={folder_id}
              name={name}
              context={context}
              isCreateSupportDocument={isCreateSupportDocument}
              handleCreateSupportDocument={handleCreateSupportDocument}
              handleSupportingDocumentButtonClick={
                handleSupportingDocumentButtonClick
              }
              DragDropFile={DragDropFile}
              setDragDropFile={setDragDropFile}
              isUploadComputer={isUploadComputer}
              workspaceId_uc={workspaceId}
              workspaceFolderId={workspaceFolderId}
              handleNameChange={handleNameChange}
              setName={setName}
              workspaceByIdStatus={workspaceByIdStatus}
            />
          ) : null}
          {isWebsiteUrl ? (
            <WebsiteUrl
              workspaceFolderFlag={workspaceFolderFlag}
              workspace_id={workspace_id}
              folder_id={folder_id}
              name={name}
              context={context}
              isCreateSupportDocument={isCreateSupportDocument}
              handleCreateSupportDocument={handleCreateSupportDocument}
              handleSupportingDocumentButtonClick={
                handleSupportingDocumentButtonClick
              }
              workspaceId_uc={workspaceId}
              workspaceByIdStatus={workspaceByIdStatus}
            />
          ) : null}
          {isOwnData ? (
            <OwnData
              workspaceFolderFlag={workspaceFolderFlag}
              workspace_id={workspace_id}
              folder_id={folder_id}
              name={name}
              context={context}
              isCreateSupportDocument={isCreateSupportDocument}
              handleCreateSupportDocument={handleCreateSupportDocument}
              handleSupportingDocumentButtonClick={
                handleSupportingDocumentButtonClick
              }
              workspaceId_uc={workspaceId}
              workspaceByIdStatus={workspaceByIdStatus}
            />
          ) : null}
          {isUploadComputer || isWebsiteUrl || isOwnData ? null : (
            <div className="supporting-document-2">
              <label>Choose from</label>
              <div
                className={`drag-drop-field supporting-document-out-2 ${
                  isDragging ? "dragging" : ""
                }`}
                onDragEnter={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDragOver={handleDragOver}
                onDrop={handleDrop}
              >
                <div className="supporting-document-upload-img-height-320">
                  <div className="supporting-document-upload-main-div">
                    <div className="supporting-document-upload-span">
                      <div className="supporting-document-upload-sub-div">
                        <div className="supporting-document-upload-middle-div-first-p">
                          {
                            "Drag & Drop Your file or click to upload (PDF, MP3, MP4, DOCX or txt files)"
                          }
                        </div>
                        <div className="supporting-document-upload-middle-div-second-p">
                          Or
                        </div>
                        <div
                          className="supporting-document-upload-middle-div-tree-p"
                          onClick={handleUploadComputer}
                        >
                          <div className="supporting-document-image-button">
                            <RiFileUploadFill className="supporting-document-sideIcon-size supporting-document-color-text" />{" "}
                            Upload from Computer
                          </div>
                        </div>
                        <div
                          className="supporting-document-upload-middle-div-tree-p"
                          onClick={handleWebsiteUrl}
                        >
                          <div className="supporting-document-image-button">
                            <RiLinkM className="supporting-document-sideIcon-size supporting-document-color-text" />{" "}
                            Scrape a Website or URL
                          </div>
                        </div>
                        <div
                          className="supporting-document-upload-middle-div-tree-p"
                          onClick={handleOwnData}
                        >
                          <div className="supporting-document-image-button">
                            <RiEditBoxFill className="supporting-document-sideIcon-size supporting-document-color-text" />{" "}
                            Enter Your Own Data
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </Drawer>
    </>
  );
};
export default CreateSupportDocument;
